import React from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'

const mapStateToProps = state => ({
    isLandScape: state.getIn(['device', 'isLandscape']),
    isMobile: state.getIn(['device', 'isDeviceMobile']) !== null,
})

const WithDontRenderMobileLandscape = WrappedComponent => ({ isLandScape, isMobile, ...props }) =>
    isLandScape && isMobile ? null : <WrappedComponent {...props} />

export default compose(
    connect(mapStateToProps),
    WithDontRenderMobileLandscape
)
